import React from 'react';
import type { OpportunityLifecycleStage } from '../../types';

export function OpportunityTimeline({ stages }: { stages: OpportunityLifecycleStage[] }) {
  return (
    <ol className="wfx-opp-lifecycle">
      {stages.map((stage, index) => (
        <li key={stage.id} className={`wfx-opp-lifecycle-step is-${stage.status}`}>
          <div className="wfx-opp-lifecycle-marker" aria-hidden="true">
            <span />
            {index < stages.length - 1 && <span className="wfx-opp-lifecycle-line" />}
          </div>
          <div className="wfx-opp-lifecycle-content">
            <strong>{stage.label}</strong>
            {stage.date && (
              <span className="wfx-muted">
                {new Date(stage.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
              </span>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
